import React from 'react'
import { motion } from 'framer-motion'
import About from '../components/About'
import './AboutPage.css'

const AboutPage = () => {
  return (
    <div className="about-page">
      <div className="container">
        <motion.div
          className="page-header"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="page-title">About Me</h1>
          <p className="page-description">
            Learn more about my journey, skills, and passion for creating amazing digital experiences.
          </p>
        </motion.div>
        <About />
      </div>
    </div>
  )
}

export default AboutPage
